import { Badge, FlexLayout, H4 } from '@deity/falcon-ui';
import { FlowContext } from 'contexts/FlowContext';
import { useContext } from 'react';
import { FooterItem } from '../FooterItem';

export const FlowSummary = () => {
  const ctx = useContext(FlowContext);

  if (!ctx?.state.flowSummary) {
    return null;
  }

  return (
    ctx?.state.flowSummary && (
      <FlexLayout justifyContent="center">
        <FooterItem bl="regular" br="regular" itemTitle="Validation">
          <FlexLayout alignItems="center" mt="xs">
            <FlexLayout
              alignItems="center"
              border="regular"
              borderRadius="small"
              pl="xs"
              pr="xs"
              borderColor={ctx.state.flowSummary.valid ? 'successDark' : 'warningDark'}
              bg={ctx.state.flowSummary.valid ? 'successLight' : 'warningLight'}
            >
              <Badge variant="round" bg="white" color="successDark">
                {ctx.state.flowSummary.messages.length}
              </Badge>
              <H4
                fontWeight="semiBold"
                fontSize="xs"
                ml="xs"
                color={ctx.state.flowSummary.valid ? 'successDark' : 'warningTextDark'}
              >
                Messages
              </H4>
            </FlexLayout>
          </FlexLayout>
        </FooterItem>
      </FlexLayout>
    )
  );
};
